import { z } from 'zod';

import type { IdDealGroupDto } from '@/services/ws-deals/src/main/resources/rest-api';

export enum DealsSearchKey {
  DEAL_GROUP = 'dealGroupFilter',
}

export const dealsRouterSearchParamsSchema = z.object({
  // A search param is a string from outside the app, so the brand is minted behind a check rather than
  // asserted: without the predicate z.custom accepts anything at all (js/rules/Api.md, Ids).
  [DealsSearchKey.DEAL_GROUP]: z.custom<IdDealGroupDto>((value) => typeof value === 'string').optional(),
});
